require("!!/Users/zhaolinxu/GitHub/IdleAnt/node_modules/script-loader/addScript.js")(require("!!/Users/zhaolinxu/GitHub/IdleAnt/node_modules/raw-loader/index.js!/Users/zhaolinxu/GitHub/IdleAnt/node_modules/mutationobserver-shim/dist/mutationobserver.min.js"))


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/~/script-loader!/Users/zhaolinxu/GitHub/IdleAnt/~/mutationobserver-shim/dist/mutationobserver.min.js
// module id = ../../../../script-loader/index.js!../../../../mutationobserver-shim/dist/mutationobserver.min.js
// module chunks = 3